export default "__VITE_ASSET__ee813310__"